// extracted by mini-css-extract-plugin
export var section = "index-module--section--3Iud1";
export var sectionBackground = "index-module--sectionBackground--2QoL7";
export var titleContainer = "index-module--titleContainer--3eKdD";
export var title = "index-module--title--ku0m6";
export var mainContainer = "index-module--mainContainer--mtGg3";
export var textsContainer = "index-module--textsContainer--1ZF-4";
export var textsContainerBorder = "index-module--textsContainerBorder--1YmmF";